module.exports = __webpack_public_path__ + "img/2.b9bfc39e.png";